var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hugeicons:tape-measure",
    clipPath: "url(#clip0_8748_113668)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.3335 5.65243C3.3335 6.39643 4.52683 6.99976 6.00016 6.99976L6.00016 5.65243C6.00016 4.98976 6.00016 4.65776 5.7355 4.45576C5.47016 4.25376 5.2075 4.32909 4.68216 4.48043C3.87683 4.71309 3.3335 5.14976 3.3335 5.65243Z",
    stroke: "#090F08",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.6668 4.66634C10.6668 5.95501 8.5775 6.99967 6.00016 6.99967C3.42283 6.99967 1.3335 5.95501 1.3335 4.66634C1.3335 3.37767 3.42283 2.33301 6.00016 2.33301C8.5775 2.33301 10.6668 3.37767 10.6668 4.66634Z",
    stroke: "#090F08",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M1.3335 5L1.3335 9.44467C1.3335 10.6713 3.42283 11.6667 6.00016 11.6667L13.3335 11.6667C13.9622 11.6667 14.2762 11.6667 14.4715 11.4713C14.6668 11.276 14.6668 10.962 14.6668 10.3333L14.6668 8.33333C14.6668 7.70467 14.6668 7.39067 14.4715 7.19533C14.2762 7 13.9622 7 13.3335 7L6.00016 7M12.0002 11.6667L12.0002 10.3333M9.3335 11.6667L9.3335 10.3333M6.66683 11.6667L6.66683 10.3333M4.00016 11.3333L4.00016 10",
    stroke: "#090F08",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8748_113668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTape);
export default __webpack_public_path__ + "static/media/tape.d02007e70ebb857bee0338d927d1e6b0.svg";
export { ForwardRef as ReactComponent };